export default {
  head: {
    title: 'Merchant Payment operations billing',
    action: {
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Merchant Payment billing operation'
    },
    details: {
      title: 'Merchant Payment operation details'
    }
  }
};
